import { memo } from "react";
import { AccessDeniedStrategy, AuthorizationChecker, getRoutePermissions } from "@tecorien/mimic";
import { RouteDescription } from "types";
import { useEntityPageParams } from "../navigation";

type RoutePermissionCheckerProps = {
  route: RouteDescription
}

export const RoutePermissionChecker = memo<RoutePermissionCheckerProps>(({ route }) => {
  const routePermissions = getRoutePermissions(route, useEntityPageParams());

  return (
    <AuthorizationChecker
      {...routePermissions}
      strategy={AccessDeniedStrategy.renderStub}
    >
      {route.element}
    </AuthorizationChecker>
  );
});